import * as ActionTypes from './ReceivableActionTypes';
import { assign } from '../../shared/Assign';
import { Translate } from '../../shared/LanguageService';
import { ILegalEntity } from './Types';
import InitialState from './InitialState';
import LegalEntityList from '../legalentities/LegalEntityList';

export default function invoiceReducer(
    state: any = InitialState,
    action: { type: string; result: any }
) {
    let newState: any;
    let legalEntity: ILegalEntity;

    switch (action.type) {
        case ActionTypes.GET_INITIAL_DATA_SUCCESS:
            newState = assign({}, state);
            let legalEntities = action.result.legalEntities as ILegalEntity[];
            for (let legalEntity of legalEntities) {
                legalEntity.customers.unshift({
                    value: 0,
                    label: Translate('receivable/filter/customer-select/default')
                });
            }

            newState.legalEntities = legalEntities;
            newState.dateTypeIds = action.result.dateTypes;
            return newState;

        case ActionTypes.GET_DATA_SUCCESS:
            newState = assign({}, state);
            legalEntity = newState.legalEntities.filter(
                (le) => le.id === action.result.legalEntityId
            )[0];

            legalEntity.invoicesInvoiced = action.result.summary.invoicesInvoiced;
            legalEntity.invoicesPaid = action.result.summary.invoicesPaid;
            legalEntity.invoicesSum = action.result.summary.invoicesSum;

            legalEntity.creditsInvoiced = action.result.summary.creditsInvoiced;
            legalEntity.creditsPaid = action.result.summary.creditsPaid;
            legalEntity.creditsSum = action.result.summary.creditsSum;

            legalEntity.totalsInvoiced = action.result.summary.totalsInvoiced;
            legalEntity.totalsPaid = action.result.summary.totalsPaid;
            legalEntity.totalsSum = action.result.summary.totalsSum;

            legalEntity.details = action.result.details;
            legalEntity.site = action.result.site;

            return newState;

        case ActionTypes.STATE_RESET:
            return InitialState;

        case ActionTypes.LEGAL_ENTITY_STATE_RESET:
            newState = assign({}, state);

            legalEntity = newState.legalEntities.filter((le) => le.id === action.result)[0];

            legalEntity.creditsInvoiced = 0;
            legalEntity.creditsPaid = 0;
            legalEntity.creditsSum = 0;

            legalEntity.details = [];

            legalEntity.invoicesInvoiced = 0;
            legalEntity.invoicesPaid = 0;
            legalEntity.invoicesSum = 0;

            legalEntity.totalsInvoiced = 0;
            legalEntity.totalsPaid = 0;
            legalEntity.totalsSum = 0;

            return newState;

        default:
            return state;
    }
}
